// extracted by mini-css-extract-plugin
export var cardLayout = "_6h-1";
export var paginationContainer = "_6h-0";